import gql from 'graphql-tag';

export default gql`
query getTemplateCollectionIdByProjectId($projectId: Int!) {
  projects(where: {project_id: {_eq: $projectId}}) {
    template_collection_id
  }
}
`;
